import React, { useState, useMemo, useCallback } from 'react';
import RoleBasedSidebar from './ui/RoleBasedSidebar';
import { useAuth } from '../contexts/AuthContext';
import WorkspaceWindowHost from '../workspace/WorkspaceWindowHost';
import EnterpriseTopbar from '../workspace/EnterpriseTopbar';

const DashboardLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { userProfile } = useAuth();

  const userRole = useMemo(() => {
    const role = userProfile?.role?.toLowerCase();
    return role === 'employee' ? 'user' : role || 'user';
  }, [userProfile?.role]);

  const handleToggleCollapse = useCallback(() => {
    setIsSidebarCollapsed(prev => !prev);
  }, []);

  const handleMobileToggle = useCallback(() => {
    setIsMobileOpen(prev => !prev);
  }, []);

  const handleMobileClose = useCallback(() => {
    setIsMobileOpen(false);
  }, []);

  return (
    <div className="cp07-app-shell flex h-screen overflow-hidden">
      <RoleBasedSidebar
        isCollapsed={isSidebarCollapsed}
        userRole={userRole}
        onToggleCollapse={handleToggleCollapse}
        isMobileOpen={isMobileOpen}
        onMobileClose={handleMobileClose}
      />

      <div
        className={`flex min-w-0 flex-1 flex-col overflow-hidden transition-[margin] duration-300 ${
          isSidebarCollapsed ? 'ml-0 md:ml-[56px]' : 'ml-0 md:ml-[220px]'
        }`}
      >
        <WorkspaceWindowHost>
          <EnterpriseTopbar
            userRole={userRole}
            onMobileMenu={handleMobileToggle}
          />

          <main className="cp07-module-canvas min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-3 py-3 pb-16 sm:px-4 lg:px-4 xl:px-5">
            <div className="min-w-0 max-w-full">{children}</div>
          </main>
        </WorkspaceWindowHost>
      </div>
    </div>
  );
};

export default React.memo(DashboardLayout);
